import { render } from "./BaseSpinner.vue?vue&type=template&id=108035b3&scoped=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"

import "./BaseSpinner.vue?vue&type=style&index=0&id=108035b3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-108035b3"

export default script